import { render } from "./SurvivorCharacter.vue?vue&type=template&id=28215974&scoped=true"
import script from "./SurvivorCharacter.vue?vue&type=script&lang=js"
export * from "./SurvivorCharacter.vue?vue&type=script&lang=js"

import "./SurvivorCharacter.vue?vue&type=style&index=0&id=28215974&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28215974"]])

export default __exports__